import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  layout: {
    minHeight: '100vh'
  },
  logo: { padding: '16px 0px 16px 24px' },
  logoIcon: {
    minWidth: 38,
    minHeight: 27,
    height: 27
  }
}))
